import { combineReducers } from '@reduxjs/toolkit';
import loginSlice from './login/loginSlice';
import resetPasswordSlice from './resetPassword/resetPasswordSlice';

const authSlice = combineReducers({
    login: loginSlice,
    resetPassword: resetPasswordSlice,
});

export default authSlice;
